module.exports = __webpack_public_path__ + "static/media/uhi-2.e2fb7a6a.png";